import script from "./Orders.vue?vue&type=script&setup=true&lang=js"
export * from "./Orders.vue?vue&type=script&setup=true&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=7fe4bd9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe4bd9c"]])

export default __exports__